<template>
  <div style="padding: 10px">
    <div class="search-pc" style="margin: 10px 0">
      <el-input v-model="roleId" placeholder="请输入角色ID" style="width: 240px; margin-right: 10px"
                clearable @keyup.enter="query"></el-input>
      <el-button type="primary" :loading="loading" @click="query">记录拉取</el-button>
      <el-input v-model="filterName" placeholder="输入名字过滤结果" style="width: 200px; margin-left: 10px"
                clearable></el-input>
    </div>
    <div class="search-mobile">
      <el-input v-model="roleId" placeholder="请输入角色ID" size="small" clearable
                class="mobile-input" @keyup.enter="query"></el-input>
      <el-button type="primary" size="small" :loading="loading" @click="query">记录拉取</el-button>
    </div>
    <div class="search-mobile mobile-filter">
      <el-input v-model="filterName" placeholder="输入名字过滤结果" size="small" clearable
                class="mobile-input"></el-input>
    </div>

    <div v-if="result" style="margin: 10px 0">
      <div class="summary-card">
        <div class="summary-item">
          <div class="summary-value">{{ result.myRank != null ? result.myRank : '-' }}</div>
          <div class="summary-label">我的巅峰排名</div>
        </div>
        <div class="summary-item">
          <div class="summary-value">{{ result.rankTotal != null ? result.rankTotal : '-' }}</div>
          <div class="summary-label">巅峰榜总人数</div>
        </div>
        <div class="summary-item">
          <div class="summary-value">{{ result.total != null ? result.total : '-' }}</div>
          <div class="summary-label">战绩条数</div>
        </div>
      </div>
    </div>

    <el-table class="table-pc" v-loading="loading" :data="filteredData" border stripe style="width: 100%"
              :empty-text="displayEmptyText">
      <el-table-column prop="time" label="时间" width="90"></el-table-column>
      <el-table-column label="攻守" width="70" align="center">
        <template #default="scope">
          <el-tag :type="scope.row.isAttack ? 'success' : 'warning'" size="mini">
            {{ scope.row.isAttackText }}
          </el-tag>
        </template>
      </el-table-column>
      <el-table-column label="输赢" width="70" align="center">
        <template #default="scope">
          <el-tag :type="scope.row.isWin ? 'danger' : 'info'" size="mini">
            {{ scope.row.isWinText }}
          </el-tag>
        </template>
      </el-table-column>
      <el-table-column prop="scoreText" label="积分变化" width="90" align="center"></el-table-column>
      <el-table-column label="巅峰排名" width="110" align="center">
        <template #default="scope">
          <span v-if="scope.row.rankText" style="color: #e6a23c">{{ scope.row.rankText }}</span>
          <span v-else style="color: #909399">未上榜</span>
        </template>
      </el-table-column>
      <el-table-column label="敌方角色" min-width="180">
        <template #default="scope">
          <div style="display: flex; align-items: center">
            <el-avatar :size="28" :src="scope.row.oppositeHead" style="margin-right: 8px; flex-shrink: 0"></el-avatar>
            <div>
              <div>{{ scope.row.oppositeName }}</div>
              <div style="font-size: 12px">ID:
                <span class="copyable-text" @click="copyToClipboard(scope.row.oppositeId)">
                  {{ scope.row.oppositeId }} <i class="el-icon-document-copy"></i>
                </span>
              </div>
            </div>
          </div>
        </template>
      </el-table-column>
      <el-table-column label="敌方阵容" min-width="220">
        <template #default="scope">
          <div>
            <el-tag type="primary" size="mini" style="margin-bottom: 4px">{{ scope.row.lineup }}</el-tag>
            <div style="font-size: 13px">{{ heroNamesText(scope.row) }}</div>
          </div>
        </template>
      </el-table-column>
    </el-table>

    <div class="table-mobile" v-loading="loading">
      <div class="card-item" v-for="item in filteredData" :key="item.id">
        <div class="card-row">
          <span class="card-label">时间：</span>
          <span class="card-value">{{ item.time }}</span>
        </div>
        <div class="card-row">
          <span class="card-label">攻守：</span>
          <span class="card-value">
            <el-tag :type="item.isAttack ? 'success' : 'warning'" size="mini">{{ item.isAttackText }}</el-tag>
            <el-tag :type="item.isWin ? 'danger' : 'info'" size="mini" style="margin-left: 6px">{{ item.isWinText }}</el-tag>
            <span style="margin-left: 8px">{{ item.scoreText }}</span>
          </span>
        </div>
        <div class="card-row">
          <span class="card-label">巅峰排名：</span>
          <span class="card-value">
            <span v-if="item.rankText" style="color: #e6a23c">{{ item.rankText }}</span>
            <span v-else style="color: #909399">未上榜</span>
          </span>
        </div>
        <div class="card-row">
          <span class="card-label">敌方角色：</span>
          <span class="card-value">
            <div style="display: flex; align-items: center">
              <el-avatar :size="24" :src="item.oppositeHead" style="margin-right: 6px; flex-shrink: 0"></el-avatar>
              <div>
                <div>{{ item.oppositeName }}</div>
                <div style="font-size: 12px">ID:
                  <span class="copyable-text" @click="copyToClipboard(item.oppositeId)">
                    {{ item.oppositeId }} <i class="el-icon-document-copy"></i>
                  </span>
                </div>
              </div>
            </div>
          </span>
        </div>
        <div class="card-row">
          <span class="card-label">敌方阵容：</span>
          <span class="card-value">
            <el-tag type="primary" size="mini" style="margin-bottom: 4px">{{ item.lineup }}</el-tag>
            <div style="font-size: 13px">{{ heroNamesText(item) }}</div>
          </span>
        </div>
      </div>
      <div v-if="filteredData.length === 0 && !loading" class="mobile-empty">{{ displayEmptyText }}</div>
    </div>
  </div>
</template>

<script>
import request from "@/utils/request";

export default {
  name: 'ArenaRecord',
  data() {
    return {
      roleId: '',
      filterName: '',
      loading: false,
      result: null,
      tableData: [],
      emptyText: '请输入角色ID后点击记录拉取'
    }
  },
  computed: {
    filteredData() {
      const kw = (this.filterName || '').trim().toLowerCase();
      if (!kw) {
        return this.tableData;
      }
      return this.tableData.filter(item => (item.oppositeName || '').toLowerCase().indexOf(kw) !== -1);
    },
    displayEmptyText() {
      const hasKw = (this.filterName || '').trim() !== '';
      if (hasKw && this.tableData.length > 0 && this.filteredData.length === 0) {
        return '无匹配的战绩记录';
      }
      return this.emptyText;
    }
  },
  methods: {
    query() {
      if (!this.roleId || String(this.roleId).trim() === '') {
        this.$message.warning('请输入角色ID');
        return;
      }
      this.loading = true;
      this.emptyText = '加载中...';
      request.get("/xyzwws/arenaRecord/query/" + String(this.roleId).trim())
        .then(res => {
          this.loading = false;
          if (res.code === '0') {
            let data = res.data;
            if (typeof data === 'string' && data) {
              data = JSON.parse(data);
            }
            if (data && data.list) {
              this.result = data;
              this.tableData = data.list;
              this.emptyText = '暂无战绩数据';
            } else {
              this.result = null;
              this.tableData = [];
              this.emptyText = '暂无战绩数据';
            }
          } else {
            this.$message.error(res.msg || '记录拉取失败');
            this.result = null;
            this.tableData = [];
            this.emptyText = '记录拉取失败，请稍后重试';
          }
        })
        .catch(() => {
          this.loading = false;
          this.$message.error('网络错误');
          this.result = null;
          this.tableData = [];
          this.emptyText = '网络错误，请稍后重试';
        });
    },
    heroNamesText(row) {
      if (row.heroNames && row.heroNames.length > 0) {
        return row.heroNames.join(' + ');
      }
      return '-';
    },
    async copyToClipboard(text) {
      if (text === null || text === undefined || text === '') {
        return;
      }
      const textToCopy = text.toString();

      if (navigator.clipboard && window.isSecureContext) {
        try {
          await navigator.clipboard.writeText(textToCopy);
          this.$message.success('复制成功');
          return;
        } catch (err) {
          console.warn('现代Clipboard API失败，使用降级方案');
        }
      }

      const textArea = document.createElement('textarea');
      textArea.value = textToCopy;
      textArea.style.position = 'fixed';
      textArea.style.opacity = '0';

      document.body.appendChild(textArea);
      textArea.select();

      try {
        const successful = document.execCommand('copy');
        if (successful) {
          this.$message.success('复制成功');
        } else {
          this.$message.error('复制失败');
        }
      } catch (err) {
        this.$message.error('复制失败');
      } finally {
        document.body.removeChild(textArea);
      }
    }
  }
}
</script>

<style scoped>
.search-pc, .table-pc { display: block; }
.search-mobile, .table-mobile { display: none; }

.summary-card {
  display: flex;
  background: #2a2a2a;
  border: 1px solid #3a3a3a;
  border-radius: 4px;
  padding: 16px 0;
}
.summary-item {
  flex: 1;
  text-align: center;
  border-right: 1px solid #3a3a3a;
}
.summary-item:last-child {
  border-right: none;
}
.summary-value {
  font-size: 22px;
  font-weight: bold;
  color: #e6a23c;
}
.summary-label {
  margin-top: 4px;
  font-size: 13px;
  color: #909399;
}

.card-item {
  background: #2a2a2a;
  border: 1px solid #3a3a3a;
  border-radius: 4px;
  padding: 12px;
  margin-bottom: 10px;
}
.card-row {
  display: flex;
  align-items: flex-start;
  padding: 5px 0;
  font-size: 14px;
}
.card-label {
  color: #909399;
  width: 80px;
  flex-shrink: 0;
}
.card-value {
  color: #e6a23c;
  flex: 1;
  min-width: 0;
}

.copyable-text {
  cursor: pointer;
  color: #409EFF;
  display: inline-flex;
  align-items: center;
  gap: 4px;
}
.copyable-text:hover {
  text-decoration: underline;
}

.mobile-empty {
  text-align: center;
  color: #909399;
  padding: 20px 0;
}

@media screen and (max-width: 768px) {
  .search-pc, .table-pc { display: none !important; }
  .search-mobile, .table-mobile { display: block !important; }
  .search-mobile {
    display: flex !important;
    align-items: center;
    gap: 10px;
    margin: 10px 0;
  }
  .search-mobile .mobile-input { flex: 1; }
  .search-mobile.mobile-filter { margin-top: 0; }
  .summary-card { padding: 12px 0; }
  .summary-value { font-size: 18px; }
  .summary-label { font-size: 12px; }
}
</style>